import React from 'react';
import { useNavigate } from 'react-router-dom';
import PortalShell from './PortalShell';

export default function PortalThanksPage() {
  const navigate = useNavigate();
  return (
    <PortalShell>
      <div style={{ maxWidth: 720, margin: '120px auto', padding: '0 24px' }}>
        <p className="portal-label" style={{ marginBottom: 14 }}>APPLICATION SUBMITTED</p>
        <h1 className="portal-hero" style={{ marginBottom: 40 }}>We've got it.</h1>
        <button type="button" onClick={() => navigate('/')} className="portal-btn">
          BACK TO PORTAL NOIR
        </button>
      </div>
    </PortalShell>
  );
}
